module.exports = __webpack_public_path__ + "img/touxiang3.21f1a4a9.png";